import { atom } from "jotai";
import WorkGroupRecord from "models/view-models/work-group/work-group-record";

const WorkGroupsAtom = atom<WorkGroupRecord[]>([]);

export default WorkGroupsAtom;
